import { useState, useEffect } from "react";
import { Alert, Button, Form, Modal, ListGroup, Spinner } from "react-bootstrap";
import { createNewProductCategory, getNewPlaces } from "../../apiForNewProducts.js";

export default function CreateNewCategory({ show, onHide, jwt, onCreated, priority }) {
    const [name, setName] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedPlaceIds, setSelectedPlaceIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Загружаем список платформ при открытии модального окна
    useEffect(() => {
        if (show) {
            loadPlaces();
        }
    }, [show]);

    const loadPlaces = async () => {
        setIsLoading(true);
        try {
            const placesData = await getNewPlaces(jwt);
            setPlaces(placesData || []);
        } catch (error) {
            console.error("Ошибка загрузки платформ:", error);
            alert("Не удалось загрузить список платформ");
        } finally {
            setIsLoading(false);
        }
    };

    const togglePlaceSelection = (placeId) => {
        setSelectedPlaceIds(prev =>
            prev.includes(placeId)
                ? prev.filter(id => id !== placeId)
                : [...prev, placeId]
        );
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await createNewProductCategory(
                name,
                priority,
                jwt,
                selectedPlaceIds.length > 0 ? selectedPlaceIds : undefined
            );

            if (response) {
                // Формируем объект категории с платформами
                const categoryWithPlaces = {
                    ...response,
                    places: places
                        .filter(p => selectedPlaceIds.includes(p.id))
                        .map(p => ({
                            productPlaceId: p.id,
                            name: p.name
                        }))
                };
                onCreated(categoryWithPlaces);
                resetForm();
            } else {
                alert('Не удалось создать, разрыв с сервером');
            }
        } catch (error) {
            console.error("Ошибка создания категории:", error);
            alert('Ошибка при создании категории');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setName('');
        setSelectedPlaceIds([]);
    };

    const handleClose = () => {
        resetForm();
        onHide();
    };

    return (
        <Modal centered show={show} onHide={handleClose}>
            <Form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Новая категория</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Название</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={isSubmitting}
                        />
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>
                            Доступные платформы
                            {isLoading && (
                                <Spinner animation="border" size="sm" className="ms-2" />
                            )}
                        </Form.Label>
                        <Form.Text className="text-muted d-block mb-2">
                            Если не выбрано ни одной платформы, категория будет доступна на всех платформах
                        </Form.Text>

                        {isLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" size="sm" />
                                <p className="mt-2">Загрузка платформ...</p>
                            </div>
                        ) : places.length > 0 ? (
                            <ListGroup style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {places.map(place => (
                                    <ListGroup.Item
                                        key={place.id}
                                        as="div"
                                        action
                                        active={selectedPlaceIds.includes(place.id)}
                                        onClick={() => togglePlaceSelection(place.id)}
                                        disabled={isSubmitting}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span>{place.name}</span>
                                            {selectedPlaceIds.includes(place.id) && (
                                                <span className="text-success">✓</span>
                                            )}
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        ) : (
                            <Alert variant="info">Нет доступных платформ</Alert>
                        )}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        Закрыть
                    </Button>
                    <Button
                        variant="success"
                        type="submit"
                        disabled={isSubmitting || !name.trim()}
                    >
                        {isSubmitting ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Создание...
                            </>
                        ) : 'Создать'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}